import { IDS } from '../requirements-assessment-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from '../requirements-assessment.actions';

class EvidenceGroupImprovementStepsGridController extends GridController {
    constructor($ngRedux,
                $state,
                NavigationService,
                AuthService,
                FileActions,
                $filter,
                $mdDialog,
                $scope
    ) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.rcoRequirementsAssessment;
        this.statePath = IDS.rcoEvidenceGroupImprovementStepsGrid;
        this.autoload = false;
        // this.filterControls = false;
        this.filterComponent = false;
        this.exportComponent = false;
        this.filterExpandButtonVisible = false
        // this.filterComponent = false;
        // this.header = false;
        this.icon = false;
        this.title = 'Action Plan';

        const user = this.AuthService.getUser();
        this.isAdmin = user.type === 'Administrator';
        this.basicTypeName = user.basicTypeName;
        this.columns = [
            {title: '#', mapper: null},
            // {title: this.$filter('translate')('COMMON.FIELD.TASK_NUMBER'),      mapper: 'task_number'},
            {title: 'Task',                                                     mapper: 'title'},
            {title: this.$filter('translate')('COMMON.FIELD.ASSIGNEE'),         mapper:
                (item) => `${item.assignee.name} (${item.assignee.type})`},
            {title: this.$filter('translate')('COMMON.DATE.DUE_DATE'),          mapper: 'due_date'},
            // {title: this.$filter('translate')('COMMON.FIELD.STATUS'),           mapper: 'statusName'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), {...Actions, ...this.FileActions})(this);

        // this.buttons = [
        //     {label: 'Details', class: 'btnGridModify', callback: this.onSelect}
        // ];
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

EvidenceGroupImprovementStepsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', 'FileActions','$filter', '$mdDialog', '$scope'];

export const evidenceGroupImprovementStepsGrid = {
    bindings: {
        adoId: '<',
        onRemove: '&',
        // onSelect: '&',
    },
    controller: EvidenceGroupImprovementStepsGridController,
    ...gridTpl
}
